var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalDissolvedSolids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4128_34530",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4128_34530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2996 25.8C18.7163 24.35 19.5621 22.8125 20.8371 21.1875C22.1121 19.5625 23.8329 17.8333 25.9996 16C28.1663 17.8333 29.8871 19.5625 31.1621 21.1875C32.4371 22.8125 33.2829 24.35 33.6996 25.8H31.5996C31.2163 24.7667 30.5579 23.6542 29.6246 22.4625C28.6913 21.2708 27.4829 20 25.9996 18.65C24.5329 20 23.3288 21.2708 22.3871 22.4625C21.4454 23.6542 20.7829 24.7667 20.3996 25.8H18.2996ZM33.8496 29.45C33.6996 30.2667 33.4371 31.0375 33.0621 31.7625C32.6871 32.4875 32.2079 33.1417 31.6246 33.725C31.0413 34.3083 30.3871 34.7833 29.6621 35.15C28.9371 35.5167 28.1746 35.7667 27.3746 35.9L33.8496 29.45ZM29.7746 27.8H32.6246L24.5246 35.9C24.1413 35.8167 23.7704 35.7208 23.4121 35.6125C23.0538 35.5042 22.7079 35.3583 22.3746 35.175L29.7746 27.8ZM24.0496 27.8H26.8996L20.6746 34.025C20.4246 33.7917 20.1871 33.55 19.9621 33.3C19.7371 33.05 19.5329 32.7833 19.3496 32.5L24.0496 27.8ZM17.9746 27.8H21.1496L18.3996 30.55C18.2663 30.1 18.1663 29.6458 18.0996 29.1875C18.0329 28.7292 17.9913 28.2667 17.9746 27.8Z",
    fill: "#008685"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDissolvedSolids);
export default __webpack_public_path__ + "static/media/total_dissolved_solids.9d21bf1190ee0c9e0445d46dd8b4a781.svg";
export { ForwardRef as ReactComponent };